import { ESortOptions } from "../components/Table/types.js";
const determineSort = ({
  selectedColumn,
  currentSortOrder,
  previousColumn
}) => {
  const sortOptionsArray = Object.keys(ESortOptions);
  const sortOptionsLength = sortOptionsArray.length;
  const currentIndex = selectedColumn !== previousColumn ? 0 : sortOptionsArray.indexOf(currentSortOrder);
  const nextIndex = currentIndex % sortOptionsLength + 1 === sortOptionsLength ? 0 : currentIndex % sortOptionsLength + 1;
  const nextSort = sortOptionsArray[nextIndex];
  const shouldSort = ESortOptions[nextSort] !== ESortOptions.noOrder;
  const newSelectedColumn = shouldSort ? selectedColumn : void 0;
  const newSortOrder = ESortOptions[nextSort];
  return { newSortOrder, newSelectedColumn };
};
export {
  determineSort
};
